var classof = require('../internals/classof-raw');

module.exports = typeof process != 'undefined' && classof(process) == 'process';



// WEBPACK FOOTER //
// /Users/stephen.tait/Local Sites/storyiq/app/public/web/wp-content/themes/jaywing/node_modules/core-js/internals/engine-is-node.js